import { PropertyType, ToolProvider } from '@/backend/types'
import { defaultToolConfig } from '@/modules/Project/Tools/tool-config-presets'
import type { ToolRegistryItem } from '@/modules/Project/Tools/tool-types'

export const o3Tool: ToolRegistryItem = {
  ...defaultToolConfig,
  label: 'o3',
  description:
    "OpenAI's most capable reasoning model, pre-trained to use chain of thought. Best for tasks that require complex, multi-step reasoning.",
  outputTypes: [
    PropertyType.text,
    PropertyType.single_select,
    PropertyType.multi_select,
    PropertyType.hub_select,
    PropertyType.json,
    PropertyType.collection,
    PropertyType.url,
    PropertyType.reference,
    PropertyType.number,
  ],
  addedAt: new Date('2025-04-23'),
  provider: ToolProvider.open_ai,
  isRateLimited: true,
  icon: 'company-openai',
}
